import { UserDto, UsersApi } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';

type SearchMutationParams = {
  name?: string;
  userProfileId?: string;
  email?: string;
};

type UseSearchUser = ({
  usersApi,
}: {
  usersApi: UsersApi;
}) => UseMutationResult<AxiosResponse<UserDto>, ErrorResponse, SearchMutationParams>;

export const useSearchUser: UseSearchUser = ({ usersApi }) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(({ name, userProfileId, email }: SearchMutationParams) =>
    usersApi.findUser(tenantId, name, userProfileId, email),
  );
};
